import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ListStatusModule } from '®shared/list-status';
import { UriModule } from '®shared/url-utils';

import { SectionListDetailsComponent } from './section-list-details.component';

@NgModule({
  imports: [CommonModule, UriModule, ListStatusModule],
  declarations: [SectionListDetailsComponent],
  exports: [SectionListDetailsComponent],
})
export class SectionListDetailsModule {}
